import { render, staticRenderFns } from "./Terms_Conditions.vue?vue&type=template&id=db40ff98&scoped=true&"
import script from "./Terms_Conditions.vue?vue&type=script&lang=js&"
export * from "./Terms_Conditions.vue?vue&type=script&lang=js&"
import style0 from "./Terms_Conditions.vue?vue&type=style&index=0&id=db40ff98&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db40ff98",
  null
  
)

export default component.exports